export const carouselDefaultStyles = {
  base: {
    backGround: true,
  },
};

type TCarouselDefaultStyles = {
  backGround: boolean;
};

export const getDefaultStyles = (version = 'base') => {
  // throw. or return empty object with warning ???
  return (carouselDefaultStyles[version] || {}) as TCarouselDefaultStyles;
};
